import React, {useContext} from 'react';
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../FirebaseAuth";
import PublicTemplate from "../../templates/PublicTemplate";
import Loader from "../../Loader";

const AuthRouter = ({children, template: Template, title: Title, ...rest}) => {
    const location = useLocation();
    document.title = Title;
    const {authUser} = useContext(AuthContext);

    if (!authUser.checked) {
        return (
            <PublicTemplate>
                <Loader text="Loading, please wait..."/>
            </PublicTemplate>
        );
    }

    if (!authUser.user) {
        return <Navigate to={"/signin?re="+location.pathname+location.search} replace />;
    }

    return (
        <Template {...rest}>
            {children}
        </Template>
    );
}
export default AuthRouter;
